// Third-Party
import { LoadingButton } from "@mui/lab";
import { Stack } from "@mui/material";

export interface IAskDostOdooConnectDialogActionsProps {
  translate: (text: string, options?: any) => string;
  isSubmitting: boolean;
  onCancel: () => void;
  onConnect: () => void;
}

export const AskDostOdooConnectDialogActions: React.FC<
  IAskDostOdooConnectDialogActionsProps
> = ({ translate, isSubmitting, onCancel, onConnect }) => {
  return (
    <Stack direction="row" spacing={1} sx={{ justifyContent: "flex-end" }}>
      <LoadingButton
        type="button"
        variant="outlined"
        size="small"
        disabled={isSubmitting}
        onClick={onCancel}
      >
        {translate("cancel")}
      </LoadingButton>
      <LoadingButton
        type="button"
        variant="contained"
        size="small"
        loading={isSubmitting}
        onClick={onConnect}
      >
        {translate(isSubmitting ? "connecting" : "connect")}
      </LoadingButton>
    </Stack>
  );
};
